import { Auth } from 'aws-amplify';
import { paths } from '../routes/routesConfig';
import {
  getClonedStringFromStorage,
  getStringFromStorage,
  removeItemFromStorage,
  setStringInLocalStorage,
} from '../services/storageService';

export const initializeAmplify = async (data, tenant, executeFedetationSignIn) => {
  if (data.federation) {
    await Auth.configure({
      userPoolId: data.userPoolId,
      userPoolWebClientId: data.clientId,
      authenticationFlowType: 'EMAIL' === data['mfa'] ? 'CUSTOM_AUTH' : undefined,
      oauth: {
        region: 'us-east-2',
        domain: data.federation.domain,
        scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
        redirectSignIn: data.federation.redirectSignIn,
        redirectSignOut: data.federation.redirectSignOut,
        responseType: 'code',
      },
      storage: window.sessionStorage,
    });
    if (executeFedetationSignIn) {
      Auth.federatedSignIn({ customProvider: data.federation.providerName, customState: tenant });
    }
  } else {
    await Auth.configure({
      userPoolId: data.userPoolId,
      userPoolWebClientId: data.clientId,
      authenticationFlowType: 'EMAIL' === data['mfa'] ? 'CUSTOM_AUTH' : undefined,
      storage: window.sessionStorage,
    });
  }
  return executeFedetationSignIn;
};

export const amplifySentResetOtp = (email) => {
  return Auth.forgotPassword(email);
};

export const amplifyForgotPasswordSubmit = (email, otp, password) => {
  return Auth.forgotPasswordSubmit(email, otp, password);
};

export const amplifySignIn = (email, password) => {
  return Auth.signIn(email, password);
};

export const amplifyGetAuthenticatedUser = () => {
  return Auth.currentAuthenticatedUser();
};

export const amplifyCompleteNewPassword = async (authenticate, password) => {
  return Auth.completeNewPassword(authenticate, password);
};

export const amplifyLogout = async (tenant?: string, amplifyConfig?: any): Promise<boolean> => {
  // try {
  //   await Auth.signOut();
  // } catch (e) {
  //   // ignore
  // }

  // If we have federation config, redirect to the Cognito hosted UI logout endpoint
  const domain = amplifyConfig?.federation?.domain;
  const redirectSignOut = `${amplifyConfig?.federation?.redirectSignOut}?tenant_code=${tenant}`;
  const clientId = amplifyConfig?.clientId || amplifyConfig?.client_id || amplifyConfig?.clientID;

  if (domain && redirectSignOut && clientId) {
    try {
      setStringInLocalStorage('tenant', tenant);
      removeItemFromStorage('fedetation');
      removeItemFromStorage('amplifyConfig');
    } catch (e) {}

    const logoutUrl = `https://${domain}/logout?client_id=${encodeURIComponent(
      clientId,
    )}&logout_uri=${encodeURIComponent(redirectSignOut)}`;
    window.location.assign(logoutUrl);
    return true;
  } else {
    try {
      await Auth.signOut({ global: true });
    } catch (e) {}
  }

  return false;
};

export const amplifySendCustomChallengeAnswer = (cognito, code) => {
  return Auth.sendCustomChallengeAnswer(cognito, code);
};

export const redirectLoginWithTenantCode = (navigate, tenantOverride?: string) => {
  const fedetation = getStringFromStorage('fedetation');

  if (fedetation) {
    removeItemFromStorage('fedetation');
  }
  const tenant = tenantOverride ?? getClonedStringFromStorage('tenant');
  navigate(paths.logoutModal + (tenant ? '?tenant_code=' + tenant : ''));
};

export const amplifyCurrentUser = () => {
  return Auth.currentAuthenticatedUser();
};

export const amplifyCurrentSession = () => {
  return Auth.currentSession();
};
